/* eslint-disable import/no-unresolved */
import * as React from 'react';
import { isEqual } from 'lodash';
import { withTranslation, i18nClient } from '@sailor/i18n-mach-pro';
import KNB from '@wmfe/mach-pro-knb';
import { throttle } from '@/src/utils/throttle';
import { buildUrl } from '@/src/utils/buildUrl';
import Constant from '@/src/utils/constant';
import { logan } from '@/shop/c_shop_golden/utils/logan';
import CouponTipsView from '@/components/MultiSkuModalGolden/Components/CouponTips';
import { MultiSkuModel } from '@/shop/shop_multi_sku_modal/component';
import MultiSpuLandscapeListView from '@/components/MultiSkuModalGolden/Components/MultiSpuLandscapeListView';
import { SameShopSpuData, SameShopSpuItem } from '@/components/MultiSkuModalGolden/Components/MultiSpuLandscapeListView/types';
import { containerHasChild, removeChildWithoutDestory } from '@/components/MultiSkuModalGolden/utils/ui';
import { reportCodeTryException } from '@/src/common/exception';
import { getDefaultPreDecisionParams, preloadPayment } from '@/src/utils/payment';
import { shopMonitor } from '@/src/pages/shop/c_shop_golden/utils/Monitor';
import { RAPTOR_KEYS } from '@/src/pages/order/order_confirm_golden/constant';
import { ValidationRequest } from '@/components/MultiSkuModalGolden/Components/MultiSkuRequest/validationRequest';
import {
  Spu,
  ShopInfo,
  GoodDetailData,
  GoodDetailSkuList,
  GoodDetailGroupList,
  GoodDetailGroupSku,
  DefaultGoodDetail,
  DefaultGroupList,
  GoodDetailMinPrice,
  CouponTips,
} from '@/pages/shop/c_shop_golden/component';
import GoodDetailFoodImage from '@/components/MultiSkuModalGolden/Components/FoodImage';
import AttrGroup from '@/components/MultiSkuModalGolden/Components/AttrGroup';
import SubmitBtn from '@/components/MultiSkuModalGolden/Components/SubmitBtn';
import Count from '@/components/MultiSkuModalGolden/Components/CountView';
import NavigationBar from '@/components/MultiSkuModalGolden/Components/Navigation';
import Remark from '@/components/MultiSkuModalGolden/Components/Remark';
import BottomToast from '@/components/MultiSkuModalGolden/Components/BottomToast';
import DiscountTag from '@/components/DiscountTag';
import { orderRequest, TypeRequest, OrderRequest } from '@/components/OrderRequest';
import {
  MULTI_SKU_ERROR_CODE, CHANGE_CART_SOURCE, CALCULATE_PRICE_STATUS, PRODUCT_SPEC_STATUS
} from '@/pages/shop/c_shop_golden/utils/constant';
import CommonDialog from '@/components/CommonDialog';
import { MultiSkuStore } from '@/components/MultiSkuModalGolden/Store';
import TrackUtils, { EVENT_TYPE, setTrackUserGetMode } from '@/components/MultiSkuModalGolden/utils/TrackUtils';
import { animationTemp } from '@/utils';
import { MutliSKUModalMonitor, MULTI_SKU_MODAL_MONITOR_VALUE } from '@/components/MultiSkuModalGolden/utils/Monitor';
import {
  SOURCE_MULTI_SKU_NUM, SOURCE_ORDER_REQUEST, SHOP_ACTIVITY_TYPE, UserGetMode, ButtonType, TOAST_TYPE
} from '@/components/MultiSkuModalGolden/constant';
import DiscountTips from '@/components/MultiSkuModalGolden/Components/DiscountTips';
import { MultiSkuSource, SelectedSku } from '@/components/MultiSkuModalGolden/Store/model';
import IconText from '@/components/IconText';
import '@/components/MultiSkuModalGolden/index.css';
import { ORDER_REQUEST_BODY } from '@/components/OrderRequest/api';

const WMRouter = Mach.requireModule('Router');
const BackPressModule = Mach.requireModule('BackPressModule');
const IOSBackPressModule = Mach.requireModule('IOSBackPressModule');
const Login = Mach.requireModule('Login');
const EventCenter = Mach.requireModule('EventCenter');

interface IProps {
  setVisible: Function;
  shopInfo?: ShopInfo;
  addShopCart?: Function;
  shopId: string;
  brandId?: number;
  userActivityStatus?: number; // 用户是否享受过活动 0未享受 1已享受
  multiSkuModel?: MultiSkuModel;
  onError?: Function; //接口请求失败
  checkSpuFail?: Function; //一口价提单异常传参
  deleteUnavailableSku?: Function; //购物车浮层进入多规格，未在可售时间需要删除
  cid: string;
}

interface IState {
  count: number; //份数
  curGoodDetail: GoodDetailData | undefined;
  couponTips: CouponTips | undefined;
  selectedSku: GoodDetailSkuList;
  totalPrice: {
    originPrice: GoodDetailMinPrice;
    discountPrice: GoodDetailMinPrice;
    currency: string;
  };
  readyToSubmit: boolean;
  scrollOffset: number;
  scrollerBottom: number; //用于适配iOS备注弹起键盘时不被遮挡
  showDialog: boolean;
  dialogMsg: {
    title: string;
    message?: string; // 提示文案
    leftText?: string; //左侧按钮默认点击后关闭选规格浮层
    rightText?: string; //右侧按钮默认关闭提示弹窗
    onClickLeftBtn?: VoidFunction;
    onClickRightBtn?: VoidFunction;
    onClickMask?: VoidFunction;
  };
  stickyTitle: boolean;
  /** 当前主sku是否满足满折 */
  curSkuIsMeetSillAmount: number;
  /** 当前主sku满足哪个阶梯的满折 */
  curSkuDiscountPriceIndex: number;
  isMoveAtTop: boolean;
  sameShopSpuData: SameShopSpuData | undefined;
}
const Toast = Mach.requireModule('Toast');
class MultiSkuModal extends React.Component<any, IState> {
  scroller: any | undefined = null;

  skuScrollerRef: any | undefined = null;

  /** sku容器外间距 */
  skuContainerMargin: number = 16;

  currSpu: Spu | undefined = undefined;

  topHeight: number = Mach.env.statusBarHeight + Mach.env.screenHeight * 0.1; //用于计算必选品锚点

  tagLayouLab: { [key: number]: { x: number; y: number; width: number; height: number; }; } = {} //规格模块和布局位置映射(新增主规格skuId映射)

  // 主规格SKU曝光MV埋点上报相关
  skuLayoutMap = new Map<number, { skuItem: any; x: number; width: number; }>(); // 主规格SKU布局信息存储
  exposedSkuIds = new Set<number>(); // 主规格SKU已曝光记录
  mainSkuScrollX: number = 0; // 主规格SKU横向滚动距离

  tagViewLab: { [key: number | string]: boolean; } = {} //规格模块和埋点上报与否映射(新增主规格skuId上报)

  productCartIndex: number | undefined = undefined; //商品在购物车内的index，用于透传和区分入口

  defaultGoodData: DefaultGoodDetail | undefined = undefined; //购物车传进来的数据

  remarkY: number = 0; //备注布局Y

  remarkRef: any = React.createRef(); //备注ref

  firstRender: boolean = true; //是否首次渲染（曝光埋点用）

  store: MultiSkuStore = new MultiSkuStore();

  modalRef: any = React.createRef(); //蒙层ref

  goodDetailRef: any = React.createRef(); //containerref

  bottomToastRef: any = React.createRef(); // 底部满折菜toast ref

  modalHeight: number = 0; //浮层高度

  showModalAnim: boolean = false;

  submitLoading: boolean = false; //判断加购按钮是否在loading状态

  previewLoading: boolean = false; //判断preview接口是否在loading

  // bottomBarHeight不能实时赋值，因为在输入备注的时候，会弹出键盘，弹出键盘时安卓端softMenuBarHeight值为0，在有底部返回按钮时，会导致底部布局被遮挡
  bottomBarHeight: number = Mach.env.softMenuBarHeight; //系统底部导航条高度

  cartSkuList = [] as DefaultGoodDetail[]; //购物车内其他菜品数据

  multiSkuSource: MultiSkuSource = {
    sourceNum: SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW,
    orderRequestSource: SOURCE_ORDER_REQUEST.SHOP_CART_POPUP
  };

  source: number = 0; //入口来源：0 店铺卡片 1 一口价 2 购物车浮层 3 919活动落地页
  moduleSource: string | undefined; // 进入门店或多规格的某个模块来源（页面来源下的细分来源 比如：金刚落地页下挂菜卡片跳转 moduleSource为1）文档：https://km.sankuai.com/collabpage/1549078841

  limitCount: number | undefined; //折扣菜的限购份数
  shopNewUserLimitCount: number | undefined; // 门店新客折扣菜限购份数
  normalDiscountLimitCount: number | undefined; // 普通折扣菜限购份数
  lxSpuId: number | undefined; // 当前埋点的spuId

  // 资源位id
  resourceId?: string;
  // 活动id
  activityId?: string;

  userGetMode: UserGetMode = UserGetMode.delivery; // 用户取餐方式，默认是外卖

  mulitSkuModalMonitor: MutliSKUModalMonitor = new MutliSKUModalMonitor();

  backPressModuleId: any;
  iosBackPressModuleId: any; // iOS返回按钮监控id
  requestSameShopSpuIdList: number[] = [] // 门店内同店铺spuId列表;
  multiSpuLandscapeListViewWrapperRef: any = null
  spuDefaultImg: string = ''
  // 是否直出多规格
  showMultiSkuDirectly: boolean = false;
  maxHeight: number = 0;
  // 价格隔离：售罄策略toast弹窗次数
  soldOutToastCount = 0;

  constructor(props: IProps) {
    super(props);
    this.state = {
      count: 1,
      curGoodDetail: undefined,
      couponTips: undefined,
      selectedSku: {} as GoodDetailSkuList,
      totalPrice: {
        originPrice: {} as GoodDetailMinPrice,
        discountPrice: {} as GoodDetailMinPrice,
        currency: '',
      },
      readyToSubmit: false,
      scrollerBottom: 50,
      dialogMsg: {
        title: '',
      },
      showDialog: false,
      stickyTitle: false,
      scrollOffset: 0,
      curSkuIsMeetSillAmount: 0,
      curSkuDiscountPriceIndex: 0,
      // 是否为吸顶状态：false为初始状态，true为吸顶
      isMoveAtTop: false,
      sameShopSpuData: undefined
    };

    if (this.props.cid) {
      TrackUtils.cid = this.props.cid;
    }
  }

  /**
     * Modal展示
     */
  handleModalShow = () => {
    const keyFrames = {
      from: { opacity: 0 },
      to: { opacity: 1 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation?.(animCartPopShow, () => { });
    // 关闭焦点的黑魔法，专门适配某些自动获取焦点的安卓手机
    if (Mach.env.isAndroid) {
      this.closeKeyBoard();
    }
  }

  /**
     * Modal消失
     */
  handleModalHidden = throttle(() => {
    const keyFrames = {
      from: { opacity: 0.8 },
      to: { opacity: 0 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation?.(animCartPopShow, () => { });
    this.hiddenContainerAnim();
    // 清空已曝光SKU记录
    this.exposedSkuIds.clear();
    setTimeout(() => { this.close(); }, 300);
  }, 300)

  showContainerAnim = () => {
    if (!this.showModalAnim) {
      return null;
    }
    const keyFrames = {
      from: { transform: 'translateY(0)' },
      to: { transform: `translateY(-${Mach.env.screenHeight})` },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.goodDetailRef?.setAnimation?.(animCartPopShow, () => { });
    this.showModalAnim = false;
  }

  hiddenContainerAnim = () => {
    this.closeKeyBoard();
    this.showModalAnim = false;
    // 定位
    const keyFrames = {
      from: { transform: `translateY(-${Mach.env.screenHeight})` },
      to: { transform: 'translateY(0)' },
    };
    const animCartPopHidden = animationTemp(keyFrames);
    this.goodDetailRef?.setAnimation?.(animCartPopHidden, (callback) => {
    });
  }

  onClickBottomToastShow = () => {
    this.bottomToastRef?.toastShow?.();
  }

  initMultiSkuSource = (originalSource: string | undefined, productCartIndex: number | undefined = undefined) => {
    if (originalSource === 'fixed-price') {
      // 一口价专区入口（一人食） source: 1
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.FIXED_PRICE,
        orderRequestSource: SOURCE_ORDER_REQUEST.FIXED_PRICE,
      };
    } else if (originalSource === 'nine_one_nine') {
      // 919活动落地页入口 source: 3
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE,
        orderRequestSource: SOURCE_ORDER_REQUEST.NINE_ONE_NINE,
      };
    } else if (productCartIndex !== undefined) {
      // 购物车浮层入口 source: 0 2
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP,
        orderRequestSource: SOURCE_ORDER_REQUEST.SHOP_CART_POPUP,
      };
    } else {
      // 门店列表商品卡片入口/ 高达入口 originalSource source > 3
      this.multiSkuSource = {
        sourceNum: Number(originalSource) || SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW,
        orderRequestSource: Number(originalSource) || SOURCE_ORDER_REQUEST.SHOP_CART_POPUP,
      };
    }
  }

  /**
     * 打开选规格浮层
     * 1.商品卡片入口
     * 2.购物车浮层入口（需要defaultGoodData和productCartIndex）
     * 3.一口价专区卡片入口（需要一口价标识）
     * @param spu
     * @param productCartIndex
     * @param defaultGoodData 购物车浮层默认商品信息
     * @param source // 入口来源： 0：门店列商品卡片列表、 1：一口价落地页、 2：门店购物车浮层、3：919活动落地页
     * @param moduleSource // 进入门店或多规格的某个模块来源（页面来源下的细分来源 比如：金刚落地页下挂菜卡片跳转 moduleSource为1）
     */

  public open(params: { spu?: Spu; productCartIndex?: number | undefined; defaultGoodData?: DefaultGoodDetail; source?: string; moduleSource?: string; cartSkuList?: any; resourceId?: string; activityId?: string; sameShopSpuIdList?: number[]; userGetMode?: UserGetMode; }) {
    this.currSpu = params.spu;

    // 资源位 id
    this.resourceId = params?.resourceId || '';
    // 活动 id
    this.activityId = params?.activityId || '';
    // 取货方式
    this.userGetMode = params?.userGetMode || UserGetMode.delivery;
    // 埋点使用
    setTrackUserGetMode(this.userGetMode);

    this.defaultGoodData = params.defaultGoodData;
    this.cartSkuList = params.cartSkuList;
    this.productCartIndex = params?.productCartIndex;
    this.initMultiSkuSource(params.source, params.productCartIndex);
    this.source = this.multiSkuSource.sourceNum;
    // 进入门店或多规格的某个模块来源(页面来源下的细分来源)
    this.moduleSource = params.moduleSource;
    this.lxSpuId = params?.spu?.spuId;
    if (params?.sameShopSpuIdList) {
      this.requestSameShopSpuIdList = params?.sameShopSpuIdList || [];
    }
    this.spuDefaultImg = params?.spu?.picturesForSpec?.[0] || '';
    this.showMultiSkuDirectly = this.source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW && !!params.spu;
    if (this.showMultiSkuDirectly) {
      // 门店页多规格直出
      this.setState({
        curGoodDetail: params.spu
      });
    }

    this.requestAPI(params?.spu);
  }

  public close() {
    this.props.setVisible(false);
  }

  componentDidMount(): void {
    this.tagViewLab = {};
    this.backPressModuleId = BackPressModule?.addBackPressListener(() => {
      this.handleModalHidden();
      return true;
      //return true; // 返回true时会阻止事件冒泡传递，因而不会执行默认的后退行为
      // return false; // 返回false时会使事件继续传递，触发其他注册的监听函数，或是系统默认的后退行为
    });
    this.iosBackPressModuleId = IOSBackPressModule?.addBackPressListener(() => {
      this.handleModalHidden();
    });
  }

  componentWillUnmount() {
    if (this.backPressModuleId) {
      BackPressModule?.removeBackPressListener(this.backPressModuleId);
    }
    if (this.iosBackPressModuleId) {
      IOSBackPressModule?.removeBackPressListener(this.iosBackPressModuleId);
    }
    // 清空已曝光SKU记录
    this.skuLayoutMap.clear();
    this.exposedSkuIds.clear();
  }

  // 高达 lx 通参
  lxMARKETFLOADINGLAYERLab = () => {
    const multiSkuModel: MultiSkuModel = this.props.multiSkuModel;
    return {
      activity_id: multiSkuModel?.activity_id,
      componentInfo: multiSkuModel?.componentInfo,
      gd_page_id: multiSkuModel?.gdPageId,
      shop_brand_id: multiSkuModel?.brandId,
      shop_id: multiSkuModel?.shopId,
      spu_id: multiSkuModel?.spuId
    };
  }

  // 活动 加购 落地页
  lxSubmitBtnClickMv = () => {

  }

  scrollToTop = () => { // 数据更新时需要自动滚动到头部
    if (this.scroller) {
      this.scroller?.scrollToOffset({ x: 0, y: 0 }, true);
    }
  }

  handleReportSameSpuView = (item: SameShopSpuItem, index: number) => {
    const lxlab = {
      sale_price: item.discountPrice?.amount || '-999',
      shop_id: this.props.shopId || '-999',
      spu_id: item.spuId,
      spu_index: index,
    };
    TrackUtils.reportMultiSameSpuChange(EVENT_TYPE.MV, this.source, lxlab);
  }

  handleChangeSpuClick = (item: SameShopSpuItem, index: number) => {
    const { curGoodDetail } = this.state;
    if (!item.spuId || curGoodDetail?.spuId === item.spuId) {
      return;
    }

    const lxlab = {
      sale_price: item.discountPrice?.amount || '-999',
      shop_id: this.props.shopId || '-999',
      spu_id: item.spuId,
      spu_index: index,
    };
    TrackUtils.reportMultiSameSpuChange(EVENT_TYPE.MC, this.source, lxlab);
    this.requestAPI({ spuId: item.spuId });
    this.scrollToTop();
  }
  renderMultiSpuView = () => {
    const { sameShopSpuData } = this.state;
    if (sameShopSpuData) {
      return (
        <view className="multi-spu-landscape-wrapper" ref={(ref) => { this.multiSpuLandscapeListViewWrapperRef = ref; }}>
          <view className="multi-spu-landscape" ref={(ref) => { this.multiSpuLandscapeViewRef = ref; }}>
            <MultiSpuLandscapeListView
              data={sameShopSpuData}
              currentSpuId={this.state.curGoodDetail?.spuId || 0}
              handleChangeSpuClick={this.handleChangeSpuClick.bind(this)}
              handleReportSpuView={this.handleReportSameSpuView.bind(this)}
            />
          </view>
        </view>
      );
    }
    return null;
  }

  multiSpuLandscapeStickTopWrapperRef: any = null
  multiSpuLandscapeViewRef: any = null
  preScrollDistance = 0; // 解决 iOS 中滑动回弹导致 scroll distance 为负数的问题
  offsetY = 0;
  originalMultiSpuLandscapeOffsetY = 0;
  performScrollForMultiSpuLandscapeListView = (offset) => {
    // 上拉时offset>0，下拉仅ios offset<0（bounce特性）
    if (offset.y >= 0) {
      // 正常判断
      this._performScrollForMultiSpuLandscapeListView(Math.round(offset.y));
    } else {
      // ios特判，取消头图从吸顶到初态出现的跳动
      if (this.preScrollDistance >= 0) {
        this._performScrollForMultiSpuLandscapeListView(0);
      }
    }
    this.preScrollDistance = offset.y;
  };

  _performScrollForMultiSpuLandscapeListView = (srollDistance) => {
    // 从初态到吸顶态需要走过的位移：头图高度
    let ceilingPoint = 0;
    const { curGoodDetail } = this.state;
    const imgUrl = curGoodDetail?.pictures?.[0];
    if (imgUrl) {
      const width = Mach.env.screenWidth;
      const height = (width * 3) / 4;
      ceilingPoint = height;
    }
    this.offsetY = srollDistance;
    if (this.multiSpuLandscapeListViewWrapperRef !== null) {
      if (srollDistance >= ceilingPoint) {
        // 超过吸顶点，执行吸顶操作
        this.handleUIChangeWhenScrollAtTop();
      } else {
        // 未超过吸顶点，当距离较近时先将吸顶区域隐藏/显示，避免出现跳动
        if ((srollDistance - ceilingPoint) > 2) {
          this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'hidden');
        } else {
          this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'visible');
        }

        // 未超过吸顶点，执行头图区域位移
        this.handleUIChangeWhenScroll();
      }
    }
  };

  // 保持吸顶态
  handleUIChangeWhenScrollAtTop = () => {
    if (this.multiSpuLandscapeViewRef && !containerHasChild(this.multiSpuLandscapeStickTopWrapperRef, this.multiSpuLandscapeViewRef)) {
      // this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'visible'); // 初始化时为隐藏态，触发吸顶才展示
      removeChildWithoutDestory(this.multiSpuLandscapeViewRef);
      this.multiSpuLandscapeStickTopWrapperRef?.appendChild(this.multiSpuLandscapeViewRef);
    }
    if (!this.state.isMoveAtTop) {
      this.setState({
        isMoveAtTop: true,
      });
    }
  };

  // 未吸顶时，头图和筛排器根据top移动
  handleUIChangeWhenScroll = () => {
    if (this.multiSpuLandscapeViewRef && !containerHasChild(this.multiSpuLandscapeListViewWrapperRef, this.multiSpuLandscapeViewRef)) {
      removeChildWithoutDestory(this.multiSpuLandscapeViewRef);
      this.multiSpuLandscapeListViewWrapperRef?.appendChild(this.multiSpuLandscapeViewRef);
      // this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'hidden'); // 初始化时为隐藏态，触发吸顶才展示
    }
    if (this.state.isMoveAtTop) {
      this.setState({
        isMoveAtTop: false,
      });
    }
  };

  render() {
    const {
      curGoodDetail, showDialog, selectedSku, count, curSkuDiscountPriceIndex, curSkuIsMeetSillAmount, sameShopSpuData
    } = this.state;

    const {
      shopInfo, shopId, t, brandId = -999
    } = this.props;
    if (!curGoodDetail) {
      return null;
    }
    const hasMultipleSkus = curGoodDetail.skuList?.length > 1;
    const hasSingleSkuWithSpec = curGoodDetail.skuList?.length === 1 && curGoodDetail.skuList[0]?.skuSpec;
    const isRenderSku = hasMultipleSkus || hasSingleSkuWithSpec;
    const showMultiSpuLandscapeListView = Number(sameShopSpuData?.sameShopSpuList?.length) > 0;
    const top = 0;
    const maxHeight = Mach.env.screenHeight - top - Mach.env.softMenuBarHeight;
    // 兼容安卓键盘弹起后，无法获取到底部按钮softMenuBarHeight的bug
    if (!this.maxHeight || this.maxHeight > maxHeight) {
      this.maxHeight = maxHeight;
    }
    //非沉浸式状态栏高度默认为24，直接写固定值，最大高度需要减去状态栏的高度
    // ----- mpweb适配origin -----
    // const defaultImmersiveStatusBarHeight = 24;
    // if (!Mach.env.statusBarHeight) {
    //   this.maxHeight -= defaultImmersiveStatusBarHeight;
    // }
    // ----- mpweb适配change -----
    // TODO m2h temp // 华为演示临时注释，后续确保statusBarHeight有值即可
    // ----- mpweb适配       -----
    const lab = {
      picture_url: curGoodDetail.pictures,
      shop_id: shopId,
      spu_description: curGoodDetail.description,
      spu_id: curGoodDetail.spuId,
      sku_id: selectedSku?.skuId,
      source_page: this.source,
      sku_number: count
    };

    if (this.firstRender) {
      this.firstRender = false;
      let groupSkuCount = 0;
      if (this.defaultGoodData?.groupList && this.defaultGoodData?.groupList?.length > 0) {
        const groupList = this.defaultGoodData?.groupList;
        for (let i = 0; i < groupList.length; i++) {
          groupList[i].groupSkuList.map(() => (groupSkuCount += 1));
        }
      }

      TrackUtils.reportMultiSkuPage(EVENT_TYPE.MV, {
        multiSkuModel: this.props.multiSkuModel,
        curGoodDetail,
        shopId,
        canUserCoupon: this.state.couponTips?.canUserCoupon,
        source: this.source,
        selectedSku,
        moduleSource: this.moduleSource || Constant.STATISTICS_NON_VALUE
      });
    }

    let submitBtnText = '';
    switch (true) {
      case this.productCartIndex !== undefined && count === 0:
        submitBtnText = t('shop_cartlayer_removeitem1');
        break;
      case this.productCartIndex !== undefined && count !== 0:
        submitBtnText = t('promodishes_update');
        break;
      default:
        submitBtnText = t('promodishes_add');
        break;
    }
    // const backgroundColor = this.productCartIndex !== undefined ? 'transparent' : '#000000CC';
    const paddingBottom = this.store.getScreenBottom();
    // 默认不隐藏备注入口
    const hideRemark = curGoodDetail?.hideRemark === 1;
    const imgUrl = curGoodDetail?.pictures?.[0];
    this.originalMultiSpuLandscapeOffsetY = imgUrl ? Math.ceil((Mach.env.screenWidth * 3) / 4) : 0;
    return (
      <view
        className="modal"
        ref={(ref: any) => this.modalRef = ref}
        style={{
          width: Mach.env.screenWidth,
          height: Mach.env.screenHeight,
          // 显示多规格浮层闪烁修复
          opacity: 0
        }}
        onLayout={() => { this.handleModalShow(); }}
      >
        <view
          style={{ top: Mach.env.screenHeight, width: Mach.env.screenWidth, height: Mach.env.screenHeight }}
          ref={(ref: any) => this.goodDetailRef = ref}
          onLayout={(frame) => {
            this.showModalAnim = true;
            if (!this.modalHeight) {
              this.showContainerAnim();
              this.modalHeight = frame.detail.height;
            }
          }}
        // onClick={() => {
        //     this.handleModalHidden();
        // }}
        >
          <view
            className="modal-container-wrapper"
            style={{ top, maxHeight: this.maxHeight }}
          >
            <view className="modal-container">
              <view className="good-detail-container">
                {/* scroller */}
                <scroller
                  style={{
                    width: Mach.env.screenWidth, flexDirection: 'column', backgroundColor: '#FFFFFF', height: '100%'
                  }}
                  bounces={false}
                  showScrollIndicator={false}
                  ref={(ref: any) => { this.scroller = ref; }}
                  onScroll={(offset: any) => {
                    this.performScrollForMultiSpuLandscapeListView(offset);
                    if (!(Number(sameShopSpuData?.sameShopSpuList?.length) > 0)) {
                      this.showStickyTitle(offset.y);
                    }
                  }}
                >
                  <content className="scroller-content" style={{ paddingBottom: this.state.scrollerBottom }} onClick={this.closeKeyBoard}>
                    {/* 商家头部名称图片 */}
                    <view
                      onLayout={(frame) => {
                        this.topHeight = frame.detail.y + frame.detail.height;
                      }}
                    >
                      <GoodDetailFoodImage
                        shopInfo={shopInfo}
                        curGoodDetail={curGoodDetail}
                        defaultImg={this.spuDefaultImg}
                        source={this.source}
                        renderMultiSpuView={showMultiSpuLandscapeListView ? this.renderMultiSpuView : undefined}
                        sameShopSpuListLength={sameShopSpuData?.sameShopSpuList?.length || 0}
                        selectedSku={selectedSku}
                        curSkuDiscountPriceIndex={curSkuDiscountPriceIndex}
                        curSkuIsMeetSillAmount={curSkuIsMeetSillAmount}
                      />
                    </view>
                    {/* 规格选择区 */}
                    <view className="detail-content-group">
                      {/* sku组*/}
                      {
                        isRenderSku ? (
                          this._renderSku()
                        ) : null
                      }
                      {/* 属性组*/}
                      {this._renderGroupList(lab)}
                    </view>
                    {hideRemark ? null : (
                      <>
                        {/* 灰色分割条 */}
                        <view className="seperator-line" />
                        <view style={{ width: '100%' }} onLayout={(frame) => { this.remarkY = frame.detail.y; }}>
                          <Remark
                            ref={this.remarkRef}
                            defaultRemark={this.defaultGoodData?.remark}
                            scrollToEdit={() => this.scrollUpRemark(this.source)}
                            scrollToSubmit={this.scrollDowmRemark}
                          />
                        </view>
                      </>
                    )}
                  </content>
                </scroller>
                {showMultiSpuLandscapeListView && <view className="multi-spu-landscape-wrapper-stick-top" ref={(ref) => { this.multiSpuLandscapeStickTopWrapperRef = ref; }} />}
                {!showMultiSpuLandscapeListView && <NavigationBar goodsName={curGoodDetail.name} lab={lab} stickyTitle={this.state.stickyTitle} />}
                {/* footer */}
                <view className="footer-view-container">
                  {
                    // 是否是满折菜
                    selectedSku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT && selectedSku.fullDiscountExtraInfo?.fullDiscountTips?.length
                      ? (
                        <DiscountTips
                          extraInfo={curGoodDetail?.extraInfo}
                          fullDiscountExtraInfo={selectedSku.fullDiscountExtraInfo}
                          onClickBottomToastShow={() => { this.onClickBottomToastShow(); }}
                        />
                      ) : null
                  }
                  <CouponTipsView
                    source={this.source}
                    shopId={this.props.shopId}
                    multiSkuModel={this.props.multiSkuModel}
                    goodDetailData={curGoodDetail}
                    couponTips={this.state.couponTips}
                    originPrice={this.state.totalPrice.originPrice}
                    discountPrice={this.state.totalPrice.discountPrice}
                    onClickToShopPreview={() => { this.props.setVisible(false); }}
                  />

                  <view className="footer-view" style={{ paddingBottom: paddingBottom - 1 }} onClick={() => { }}>
                    {/** 一口价、919活动不展示加购按钮 */}
                    {this.multiSkuSource.orderRequestSource === SOURCE_ORDER_REQUEST.SHOP_CART_POPUP
                      && (
                        <view className="btn-area">
                          <Count defaultCount={this.defaultGoodData?.count} changeCount={this.changeCountNumber} lab={lab} count={count} />
                        </view>
                      )}
                    <view className="add-food-btn">
                      <SubmitBtn
                        totalPrice={this.state.totalPrice}
                        ready={this.state.readyToSubmit}
                        clickAddBtn={this.clickAddBtn}
                        btnText={submitBtnText}
                        showPrice={count !== 0}
                        source={this.source}
                        lxClickMv={this.lxSubmitBtnClickMv}
                      />
                    </view>
                  </view>
                </view>
                {showDialog && this._renderDialog()}
                {
                  selectedSku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT && selectedSku.fullDiscountExtraInfo?.fullDiscountToast.length
                    ? (
                      <BottomToast
                        fullDiscountExtraInfo={selectedSku.fullDiscountExtraInfo}
                        ref={(ref: any) => {
                          this.bottomToastRef = ref;
                        }}
                        key={selectedSku.skuId}
                      />
                    ) : null
                }
              </view>
              {/* 叉号固定定位，需要在图片的上面，所以把dom挪到后面，使用flex倒向，覆盖过去 */}
              <view
                className="good-detail-close-area" style={{
                  top: Mach.env.statusBarHeight,
                }}
              >
                <view
                  className="good-detail-close-area-icon-wrapper"
                  onClick={() => {
                    this.handleModalHidden();
                  }}
                >
                  <image className="good-detail-close-area-icon" src="assets://shop/multi_sku_close_icon.png" />
                </view>
              </view>
            </view>
          </view>
        </view>
      </view>
    );
  }

  // 处理主规格曝光MV上报
  handleReportMainSkuMV = (skuItem) => {
    if (!skuItem) return;
    const { shopId } = this.props;
    const { curGoodDetail } = this.state;
    const lab = {
      shop_id: shopId,
      spu_id: curGoodDetail?.spuId,
      sku_id: skuItem.skuId,
      original_price: skuItem.originPrice?.displayText,
      sale_price: skuItem.discountPrice?.displayText,
    };

    TrackUtils.reportMainSkuMV(this.source, lab);
  }

  // 单个主规格是否可见检查
  checkSingleSkuVisibility = (skuId: number) => {
    const layout = this.skuLayoutMap.get(skuId);
    if (!layout || this.exposedSkuIds.has(skuId)) return;

    // 计算元素相对位置
    const elementStart = layout.x - this.mainSkuScrollX;
    const elementEnd = elementStart + layout.width;

    // 曝光条件：元素进入可视区域
    const isVisible = elementEnd > 0 && elementStart < Mach.env.screenWidth;

    if (isVisible) {
      const { skuItem } = layout;
      this.handleReportMainSkuMV(skuItem);
      this.exposedSkuIds.add(skuId);
    }
  };

  // 主规格 滚动结束后触发检查
  checkAllSkuVisibility = () => {
    this.skuLayoutMap.forEach((_, skuId) => {
      this.checkSingleSkuVisibility(skuId);
    });
  };

  _renderSku = () => {
    const { curGoodDetail } = this.state;
    const { t } = this.props;
    if (!curGoodDetail) {
      return null;
    }
    let scrollerKey = 'scroller-con';
    (curGoodDetail.skuList || []).map((item: GoodDetailSkuList) => {
      scrollerKey += item.skuId;
    });
    /**
         * 先构造好数据
         * 1. 判断属于哪个阶梯的逻辑
         * 2. 动态标签展示的逻辑
         */
    return (
      // ----- mpweb适配origin -----
      // <view className="sku-group" onLayout={(frame) => { this.topHeight += frame.detail.y + frame.detail.height; }}>
      // ----- mpweb适配change -----
      <view className="sku-group">
        {/*// ----- mpweb适配       -----*/}
        {/* 灰色分割条 */}
        <view className="seperator-line" />
        <view className="group-content">
          <text className="group-title" content={t('cartlayer_select_spec')} />
          <view style={{ marginTop: 8, marginBottom: 16, width: '100%' }}>
            <scroller
              showScrollIndicator={false}
              className="activity-scroller"
              onscrollEnd={(offset: any) => {
                this.setState({
                  scrollOffset: offset.x
                });
                this.mainSkuScrollX = offset.x; // 更新滚动位置
                this.checkAllSkuVisibility(); // 触发可见性检查
              }}
              key={scrollerKey}
              ref={(ref: any) => { this.skuScrollerRef = ref; }}
            >
              <content flexibleHeight>
                {curGoodDetail.skuList.map((item: GoodDetailSkuList, index: number) => {
                  const highLight = this.itemIsSelected(item.skuId);
                  const { discountPriceIndex = 0, isMeetSillAmount } = this.skuIsMeetSillAmount(item);
                  // 满折多阶梯，展示对应阶梯的价格和标签
                  const discountPriceList = item.discountPriceList || [];
                  const discountPriceText = discountPriceList[discountPriceIndex]?.discountPrice?.displayText;
                  const promotionTagInfo = discountPriceList[discountPriceIndex]?.promotionTagInfo;
                  const fullDiscountTag = promotionTagInfo?.discountTag;
                  /** 新人折扣菜标签（仅折扣菜有） */
                  const discountTypeTag = item?.promotionTagInfo?.discountTypeTag;
                  const discountTag = item?.promotionTagInfo?.discountTag;
                  const border = highLight ? '2px solid #FFD900' : '2px solid #F7F7F7';
                  const backgroundColor = highLight ? '#FFFDEB' : '#F5F6FA';
                  const discountPrice = item.discountPrice ? item.discountPrice?.displayText : item.originPrice.displayText;
                  const originPrice = item.originPrice?.displayText;
                  const showOrigin = discountPrice !== originPrice;
                  const lastItemIndex = curGoodDetail.skuList.length - 1;
                  if (this.tagLayouLab[item.skuId] && !this.tagViewLab[item.skuId]) {
                    this.onskuItemAppear(item, curGoodDetail);
                  }
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <view
                      style={{
                        border, backgroundColor, marginLeft: index === 0 ? this.skuContainerMargin : 8, marginRight: index === lastItemIndex ? this.skuContainerMargin : 0
                      }}
                      className="group-item"
                      onClick={() => { this.clickSkuItem(index); }}
                      onLayout={(layout) => {
                        if (!this.tagViewLab[item.skuId]) {
                          this.onskuItemAppear(item, curGoodDetail);
                        }
                        // 初始化时滚动到选中sku
                        if (item.skuId === this.defaultGoodData?.skuId && layout.detail?.x) {
                          this.skuScrollerRef?.scrollToOffset({ x: layout.detail.x - this.skuContainerMargin, y: 0 }, true);
                        }

                        // 主规格MV上报相关
                        const detail = layout.detail;
                        this.tagLayouLab[item.skuId] = detail;

                        // 存储布局信息到新变量
                        this.skuLayoutMap.set(item.skuId, {
                          skuItem: item,
                          x: detail.x,
                          width: detail.width
                        });
                        // 立即检查当前可见性
                        this.checkSingleSkuVisibility(item.skuId);
                      }}
                    >
                      <text className="group-item-name" content={item.skuSpec} />
                      {item.calorie?.length > 0 && (
                        <text className="group-item-calorie-text" content={item.calorie} />
                      )}
                      {
                        // 参与满折活动
                        item.activityInfoList?.[0].activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT
                          ? (
                            <view className="group-item-discount-price-container">
                              <text className="group-item-price" content={originPrice} />
                              {
                                isMeetSillAmount
                                  ? (
                                    <view className="group-price-discount-container">
                                      <text
                                        className="group-price-discount-price-text"
                                        style={{ color: curGoodDetail.extraInfo?.discountPriceColor || '#713901' }}
                                        content={discountPriceText}
                                      />
                                      {/* 满折多阶梯条件时展示 */}
                                      {fullDiscountTag ? (
                                        <view className="discount-tag-margin-left">
                                          <DiscountTag tag={fullDiscountTag} />
                                        </view>
                                      ) : null}
                                    </view>
                                  ) : null
                              }
                            </view>
                          )
                          : (
                            <>
                              <view className="group-item-price-container">
                                <text className="group-item-price" content={discountPrice} />
                                {showOrigin && <text className="group-item-origin-price" content={originPrice} />}
                                {/* 折扣比例 */}
                                {discountTag ? (
                                  <view className="discount-tag-margin-left">
                                    <DiscountTag tag={discountTag} />
                                  </view>
                                ) : null}
                              </view>
                              {/* 新客折扣菜 */}
                              {discountTypeTag ? (
                                <view className="spu-discount-type-tag">
                                  <DiscountTag
                                    tag={discountTypeTag}
                                    extraStyle={{ fontFamily: 'KeeTa-Regular' }} // 新客折扣菜字体不加粗
                                  />
                                </view>
                              ) : null}
                            </>
                          )
                      }
                    </view>
                  );
                })}
              </content>
            </scroller>
          </view>
        </view>
      </view>
    );
  }

  _renderGroupList = (lab: any) => {
    const { curGoodDetail, curSkuIsMeetSillAmount, curSkuDiscountPriceIndex } = this.state;
    if (!curGoodDetail) {
      return null;
    }
    const selectedIndex = curGoodDetail?.skuList?.findIndex((item) => (item.skuId === this.state.selectedSku?.skuId));
    return (
      <view className="attr-group">
        {curGoodDetail?.skuList?.map((item: GoodDetailSkuList, index: number) => {
          if (item.groupList?.length > 0) {
            return selectedIndex === index && item.groupList.map((group: GoodDetailGroupList) => {
              if (this.tagLayouLab[group.groupId]) {
                this.onItemAppear(group);
              }
              const mustGroupList = this.store.getRequiredListBySkuId(this.state.selectedSku.skuId);
              const attrRef = mustGroupList.find((mustGroup) => mustGroup.groupId === group.groupId)?.ref;
              return (
                // eslint-disable-next-line react/jsx-key
                <view
                  onLayout={(frame) => {
                    this.tagLayouLab[group.groupId] = frame.detail;
                    this.onItemAppear(group);
                  }}
                >
                  <AttrGroup
                    ref={attrRef}
                    groupData={group}
                    changeSelectedAttrs={this.changeSelectedAttrs}
                    skuId={this.state.selectedSku.skuId}
                    isMeetSillAmount={curSkuIsMeetSillAmount}
                    curSkuDiscountPriceIndex={curSkuDiscountPriceIndex}
                    lab={lab}
                    store={this.store}
                    sku={item}
                    count={this.state.count}
                    spuId={curGoodDetail?.spuId}
                    shopId={this.props.shopId}
                    source={this.source}
                    onGroupCompleted={this.handleGroupCompleted}
                    getNextRequiredGroup={this.getNextRequiredGroup}
                  />
                </view>
              );
            });
          }
        })}
      </view>
    );
  }

  _renderDialog = () => {
    const { dialogMsg } = this.state;
    return (
      <CommonDialog
        title={dialogMsg.title}
        message={dialogMsg.message}
        leftBtnText={dialogMsg.leftText}
        rightBtnText={dialogMsg.rightText}
        onClickLeftBtn={dialogMsg.onClickLeftBtn ? dialogMsg.onClickLeftBtn : () => {
          this.setState({
            showDialog: false,
          });
        }}
        onClickRightBtn={dialogMsg.onClickRightBtn ? dialogMsg.onClickRightBtn : () => {
          this.setState({
            showDialog: false,
          });
        }}
        onClickMask={dialogMsg.onClickMask ? dialogMsg.onClickMask : () => {
          this.setState({
            showDialog: false,
          });
        }}
      />
    );
  }
  private showStickyTitle = (offsetY) => {
    const { curGoodDetail, stickyTitle } = this.state;
    if (offsetY >= (curGoodDetail?.pictures[0] ? Mach.env.screenWidth * 0.75 - 44 : 8)) {
      if (!stickyTitle) {
        this.setState({
          stickyTitle: true,
        });
      }
    } else {
      if (stickyTitle) {
        this.setState({
          stickyTitle: false,
        });
      }
    }
  }

  /**
   * 一人食 获取spu失败 回调
   * @param spuId
   * @param sameShopSpuData
   * @param curGoodDetail
   */
  checkSpuFailCallback = (spuId) => {
    const { curGoodDetail, sameShopSpuData } = this.state;
    if (!sameShopSpuData?.sameShopSpuList?.length) {
      EventCenter.emit('FixedpriceCheckSpuFail', { spuId });
      // 当没有同店铺商品时，关闭浮层
      Mach.sendEvent('close');
    } else {
      // 过滤多规格弹层中的商品,当前规格浮层存在同店铺SPU,仅需在切换SPU时将商品移除
      if (sameShopSpuData?.sameShopSpuList?.length > 0 && curGoodDetail?.spuId !== spuId) {
        // eslint-disable-next-line max-len
        const _sameShopSpuData = { ...sameShopSpuData };
        _sameShopSpuData.sameShopSpuList = sameShopSpuData?.sameShopSpuList?.filter((item) => item?.spuId !== spuId) || [];
        this.setState({
          sameShopSpuData: _sameShopSpuData
        });
        EventCenter.emit('FixedpriceCheckSpuFail', { spuId: -1 });
      }
    }
  }

  private requestAPI = (spu?: Spu) => {
    const { sameShopSpuData } = this.state;
    const {
      t, checkSpuFail, onError, shopId, deleteUnavailableSku
    } = this.props;
    let func: Function | undefined;
    switch (true) {
      case this.source === SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP:
        func = deleteUnavailableSku;
        break;
      case this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE:
        func = this.checkSpuFailCallback;
        break;
      case this.source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE:
        func = checkSpuFail;
        break;
      default:
        func = onError || this.handleModalHidden;
        break;
    }
    let sameShopSpuIdList = this.requestSameShopSpuIdList;
    if (Number(sameShopSpuData?.sameShopSpuList?.length) > 0) { // 如果已经有数据，请求中不再携带参数值
      sameShopSpuIdList = [];
    }
    const param = {
      spuId: spu?.spuId || this.defaultGoodData?.spuId || 0,
      shopId,
      requestSource: this.source,
      couponInfo: this.props.multiSkuModel?.couponInfo,
      func,
      btnText: t('shop_cartlayer_clear2'),
      productCartIndex: this.productCartIndex,
      activityId: this.activityId,
      userGetMode: this.userGetMode,
      sameShopSpuIdList,
    };

    this.store.loadData(param, (isSuccess: boolean, curGoodDetail: GoodDetailData, code: number) => {
      if (isSuccess) {
        if (sameShopSpuData && curGoodDetail.spuId !== this.state.curGoodDetail?.spuId) {
          // 清除选中的规格
          this.store.clearSelectedList();
        }
        // 有新人折扣菜 + 有普通折扣菜
        const activityInfo = curGoodDetail.activityInfoList?.[0];
        const isDiscountSpu = activityInfo?.activityType === SHOP_ACTIVITY_TYPE.DISCOUNT_FOOD;
        this.shopNewUserLimitCount = Number(activityInfo?.extraInfo.shopNewUserLimitCount) || 0;
        this.normalDiscountLimitCount = Number(activityInfo?.extraInfo.normalDiscountLimitCount) || 0;
        const totalLimitCount = this.shopNewUserLimitCount + this.normalDiscountLimitCount;

        // 待删除limitCount
        // const limitActivityInfo = curGoodDetail.activityInfoList?.find((item) => ( item.activityType === 18 && (item.extraInfo.limitCount !== undefined )));
        // this.limitCount = Number(limitActivityInfo?.extraInfo?.limitCount);
        const cartSpuCount = this.store.spuCountInCart();
        const selectedSku = this.store.initDetailData(shopId, curGoodDetail.skuList, curGoodDetail?.chooseSkuId);
        const hideRemark = curGoodDetail?.hideRemark === 1;
        // 选择sku是否满折
        const isMeetSillAmount = selectedSku.fullDiscountExtraInfo?.isMeetSillAmount;
        // 选择sku满折所在阶梯
        const curSkuDiscountPriceIndex = this.handleCurSkuDiscountPriceIndex(selectedSku);
        if (curGoodDetail?.sameShopSpuData?.sameShopSpuList?.length && sameShopSpuData === undefined) {
          // 同店铺数据，仅在第一次请求时赋值,保证不修改sku顺序
          this.setState({
            sameShopSpuData: curGoodDetail.sameShopSpuData
          });
        }
        //后端算价
        this.setState({
          curGoodDetail,
          couponTips: curGoodDetail?.couponTips,
          selectedSku,
          count: this.defaultGoodData?.count || 1,
          totalPrice: {
            originPrice: curGoodDetail.minPrice,
            discountPrice: curGoodDetail.discountPrice,
            currency: curGoodDetail.minPrice.currency
          },
          readyToSubmit: this.store.verificateProducts(selectedSku),
          scrollerBottom: hideRemark ? 24 : 50,
          curSkuIsMeetSillAmount: isMeetSillAmount || 0,
          curSkuDiscountPriceIndex,
        });
        // 显示备注的时候去曝光
        if (!hideRemark) {
          TrackUtils.reportRemark(EVENT_TYPE.MV, this.source, this.props.shopId, curGoodDetail?.spuId, this.props.multiSkuModel, curGoodDetail, this.props.shopId, this.state.couponTips?.canUserCoupon);
        }
        //从卡片进来的话要弹限购逻辑哦
        // 新人折扣菜 shopNewUserLimitCount && 超过限购份数1份
        if (this.source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW && isDiscountSpu && this.shopNewUserLimitCount && cartSpuCount === this.shopNewUserLimitCount) {
          setTimeout(() => {
            Toast.show(i18nClient.getText('promodishes_limit_toast', { limit: this.shopNewUserLimitCount }), 2);
          }, 500);
        }
        // 新人折扣菜（可能为0） + 有普通折扣菜 normalDiscountLimitCount && 超过限购份数1份
        if (this.source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW && isDiscountSpu && this.normalDiscountLimitCount && cartSpuCount === totalLimitCount) {
          setTimeout(() => {
            Toast.show(i18nClient.getText('promodishes_mostamountoff', { amount: totalLimitCount }), 2);
          }, 500);
        }
        // 监控埋点
        this.multiSkuModalOpenRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
      } else {
        // 监控埋点
        this.multiSkuModalOpenRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, code ?? '-1');
      }
    }, this.showMultiSkuDirectly, this.defaultGoodData, this.cartSkuList);
  }

  /**
      * 打开多规格弹窗浮窗成功率监控
      */
  multiSkuModalOpenRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalOpenRate(value, params);
  }

  /**
     * 菜品precheck接口成功率
     */
  multiSkuModalPrecheckRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalPrecheckRate(value, params);
  }
  /**
     * 订单preview接口成功率
     */
  multiSkuModalPreviewRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalPreviewRate(value, params);
  }
  /**
     * 监控埋点通用参数
     */
  getMultiSkuModalMonitorCommonParam = (code: number) => {
    const spuId = this.lxSpuId ?? '-1';
    const shopId = this.props.shopId ?? '-1';
    const orderSource = this.source ?? '-1';
    const activityId = this.activityId ?? '';
    const params = {
      spuId, shopId, orderSource, code, activityId
    };
    return params;
  }

  private findDefaultGroupData = (groupId: number): any => {
    const groupList: DefaultGroupList[] | undefined = this.defaultGoodData?.groupList;
    let defaultGroupData;
    if (groupList) {
      defaultGroupData = groupList.find((item) => item.groupId === groupId);
    }
    return defaultGroupData;
  }

  //点击选择sku的逻辑
  private clickSkuItem = (index: number) => {
    const { curGoodDetail, selectedSku } = this.state;
    const sku = curGoodDetail?.skuList[index]; // 当前点击的sku

    if (!curGoodDetail || !sku || isEqual(sku, selectedSku)) {
      return null;
    }

    // 主规格MC上报
    const { shopId } = this.props;
    const lab = {
      shop_id: shopId,
      spu_id: curGoodDetail.spuId,
      sku_id: sku.skuId,
      original_price: sku.originPrice?.displayText,
      sale_price: sku.discountPrice?.displayText,
    };
    TrackUtils.reportMainSkuMC(this.source, lab);

    //构造当前数据去请求购物车接口
    this.calculatePriceByBE(sku);
  }

  //判断当前item是否被选中
  private itemIsSelected = (skuId: number): boolean => (this.state.selectedSku && this.state.selectedSku.skuId === skuId)

  private handleCurSkuDiscountPriceIndex = (curSku: SelectedSku | GoodDetailSkuList): number => {
    let discountPriceIndex = 0;
    const isMeetSillAmount = curSku.fullDiscountExtraInfo?.isMeetSillAmount || 0;
    const isFullDiscount = curSku.activityInfoList?.[0].activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT;
    if (!isFullDiscount || (isFullDiscount && !isMeetSillAmount)) {
      return discountPriceIndex;
    }
    // 满折所在阶梯金额
    const sillAmount = curSku.fullDiscountExtraInfo?.sillAmount?.amount || 0;
    const discountPriceList = curSku.discountPriceList || [];
    const len = discountPriceList.length;
    let hasSillAmount = false;
    (discountPriceList || []).forEach((discountPriceItem, i) => {
      const sillAmountItem = discountPriceItem.sillAmount?.amount || 0;
      if (sillAmountItem === sillAmount) {
        discountPriceIndex = i;
        hasSillAmount = true;
      }
      // 满足满折多阶梯但未找到对应阶梯金额，告警
      if (len === i + 1 && !hasSillAmount) {
        logan({
          message: 'shop multiSkuModal error',
          shopId: this.props.shopId,
          skuId: curSku.skuId,
          discountPriceList,
          sillAmount,
        });
        shopMonitor.reportMetrics({
          ShopMultiSkuModalError: 1,
        });
      }
    });
    return discountPriceIndex;
  }

  /**
     * 当前主sku是否满足满折条件 和 满折sku所在阶梯
     * @param curSku
     * @returns
     */
  private skuIsMeetSillAmount = (curSku: GoodDetailSkuList): { isMeetSillAmount: number; discountPriceIndex: number; } => {
    let isMeetSillAmount = 0;
    let discountPriceIndex = 0;
    this.store.selectedList.forEach((item) => {
      if (item.skuId === curSku.skuId) {
        // 每个主sku是否满折
        isMeetSillAmount = item.fullDiscountExtraInfo?.isMeetSillAmount || 0;
        // 满折所在阶梯index
        discountPriceIndex = this.handleCurSkuDiscountPriceIndex(item);
      }
    });

    return {
      isMeetSillAmount,
      discountPriceIndex
    };
  }

  //更新和存储已选group规格逻辑
  private changeSelectedAttrs = (groupId: number, groupSkuList: GoodDetailGroupSku[], func?: any) => {
    const { selectedSku } = this.state;
    this.calculatePriceByBE(selectedSku, undefined, undefined, groupId, groupSkuList, (res) => {
      if (res) { func(); }
    });
  }

  private calculateTotalLimitCount = (): number => (this.shopNewUserLimitCount ?? 0) + (this.normalDiscountLimitCount ?? 0)
  /**
     * 后端算价逻辑
     * @param selectedSkuData //已选择的sku
     * @param count //数量
     * @returns
     */

  private calculatePriceByBE = async (selectedSkuData: GoodDetailSkuList, countNumber?: number, purchaseType?: number, groupId?: number, groupSkuList?: GoodDetailGroupSku[], callback?: Function) => {
    if (this.store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING || this.store.getSpecStatus() === PRODUCT_SPEC_STATUS.LOADING) {
      return;
    }
    const countTemp = (countNumber !== undefined) ? (purchaseType ? countNumber + 1 : countNumber - 1) : this.state.count;
    const cartSpuCount = this.store.spuCountInCart();
    const calData = this.store.createRequestData(this.source, selectedSkuData, countTemp, groupId, groupSkuList, this.props.multiSkuModel?.couponInfo, this.activityId);
    // const showLimitToast = type === 1 && this.limitCount && (this.limitCount + 1 === cartSpuCount + countTemp);
    const totalLimitCount = this.calculateTotalLimitCount();
    const showShopNewUserLimitToast = purchaseType === ButtonType.ADD && this.shopNewUserLimitCount && (this.shopNewUserLimitCount + 1 === cartSpuCount + countTemp);
    const showNormalDiscountLimitToast = purchaseType === ButtonType.ADD && this.normalDiscountLimitCount && (totalLimitCount + 1 === cartSpuCount + countTemp);

    try {
      const res = await this.store.calByBE(calData);
      // 超出折扣菜库存Toast
      // const overStockToast = res.activityPopType === 1 && res.activityPopText;
      this.store.changeCalStatus(CALCULATE_PRICE_STATUS.SUCCESS);
      const fullDiscountExtraInfo = res.fullDiscountExtraInfo;
      const selectedSku = { ...selectedSkuData, fullDiscountExtraInfo };
      // 选择sku满折所在阶梯
      const curSkuDiscountPriceIndex = this.handleCurSkuDiscountPriceIndex(selectedSku);
      this.store.changeSelectedList(selectedSkuData.skuId, fullDiscountExtraInfo);
      this.setState({
        selectedSku,
        couponTips: res.couponTips,
        totalPrice: {
          discountPrice: res.discountPrice,
          currency: res.discountPrice?.currency,
          originPrice: res.originPrice,
        },
        count: countTemp,
        readyToSubmit: this.store.verificateProducts(selectedSkuData),
        curSkuIsMeetSillAmount: fullDiscountExtraInfo?.isMeetSillAmount || 0,
        curSkuDiscountPriceIndex,
      }, () => {
        // 展示新人折扣菜toast：有新人折扣菜 shopNewUserLimitCount && 超过限购份数1份
        if (showShopNewUserLimitToast) {
          Toast.show(i18nClient.getText('promodishes_limit_toast', { limit: this.shopNewUserLimitCount }), 2);
        }
        // 展示普通折扣菜toast：新人折扣菜（可能为0） + 有普通折扣菜 normalDiscountLimitCount && 超过限购份数1份
        if (showNormalDiscountLimitToast) {
          Toast.show(i18nClient.getText('promodishes_mostamountoff', { amount: totalLimitCount }), 2);
        }
      });
      const toastText = res.toastInfo?.toastText || '';
      const toastType = res.toastInfo?.toastType;
      // 价格隔离：商品价格变化 售罄toast只弹一次
      if (!this.soldOutToastCount && toastType === TOAST_TYPE.SOLD_OUT && toastText) {
        Toast.show(toastText, 2);
        this.soldOutToastCount = 1;
      }
      if (toastType === TOAST_TYPE.PRICE_CHANGE && toastText) {
        Toast.show(toastText, 2);
      }
      if (callback) {
        callback(true);
      }
    } catch (error: any) {
      this.store.changeCalStatus(CALCULATE_PRICE_STATUS.ERROR);
      this.showRequestError(error);
      // 捕获到异常上报
      reportCodeTryException({
        message: 'calculatePriceByBE',
        extra: error
      });
    }
  }

  /**
     * 网络请求系统异常的toast
     */
  private showRequestError = (error, hasShowedDialog = false) => {
    const { t, checkSpuFail } = this.props;
    this.submitLoading = false;
    if (error.code === MULTI_SKU_ERROR_CODE.STYSTEMERROR) {
      Toast.show(t('shouye_default_4'), 2, {
        type: 'B', // 异常类型，B为后端异常
        code: error.code || '0', // 异常码
        extraInfo: {
          msg: error.message,
          method: 'ValidationRequest',
        }, // 附加异常信息
      });
    } else {
      if (!hasShowedDialog) {
        Toast.show(this.isFixedPriceSource() ? t('fixprice_default') : error.message, 2);
      }
      // 若一人食中已经展示了Dialog，则已经在perCheck校验接口中处理了，这里不再处理
      if (this.isFixedPriceSource()) {
        if (!hasShowedDialog) {
          setTimeout(() => { checkSpuFail(this.state.curGoodDetail?.spuId); }, 2000);
        }
      } else {
        setTimeout(() => { this.handleModalHidden(); }, 2000);
      }
    }
  }

  //加购按钮点击
  private clickAddBtn = () => {
    const {
      selectedSku, curGoodDetail, count, couponTips, totalPrice, readyToSubmit,
    } = this.state;
    if (!curGoodDetail) {
      return null;
    }
    const { multiSkuModel, shopId } = this.props;
    const { tab_id, tab_index } = this.currSpu || {};
    // 多规格点击加购按钮埋点上报（加购、未加购）,点击可能触发锚点
    let successAddCart = 0;

    if (this.submitLoading) {
      return;
    }
    if (count === 0) {
      this.deleteShopCartItem();
    } else {
      if (readyToSubmit) {
        this.addToShopcartParams();
        successAddCart = 1;
      } else {
        this.anchorMustGroup();
      }
      TrackUtils.reportAddShopcart(EVENT_TYPE.MC, 'sailor_c', this.source, totalPrice, shopId, selectedSku, count, curGoodDetail, {
        multiSkuModel,
        couponTips
      }, tab_id, tab_index, successAddCart);
    }
  }

  /**
     * 获取灵犀埋点用户活动状态
     * @returns
     */
  getLxUserActivityStatus = () => {
    const { userActivityStatus } = this.props;
    // 1 活动新客 2 活动老客
    return userActivityStatus === 0 ? 1 : 2;
  }

  /**
     * 获取灵犀埋点弹窗原因
     */
  getLxRemindReason = (code) => {
    const reason = {
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE]: 1, // 活动已结束
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK]: 2, // 无库存
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE]: 3, // 重复购买
      [MULTI_SKU_ERROR_CODE.SHOP_PRODUCT_OFF]: 1, // 商品下架删除
      [MULTI_SKU_ERROR_CODE.SHOP_REST]: 2, // 商家打烊
    };
    const reasonCode = reason?.[code] ?? -999;
    return reasonCode;
  }

  //加购到购物车
  private addToShopcartParams = () => {
    const {
      curGoodDetail,
    } = this.state;
    if (!curGoodDetail) {
      return null;
    }

    this.validRequest();
  }

  private getOrderData = (): any => {
    const {
      selectedSku, curGoodDetail, count, totalPrice
    } = this.state;
    //为兼容历史逻辑后端要求搞两套
    const groupSkuReqIDs: { groupSkuId: number; count: number; }[] = [];
    const groupSkuIDs: number[] = [];
    let remark = '';
    const { current } = this.remarkRef || {};
    if (current) {
      remark = current.inputText();
    } else {
      remark = this.defaultGoodData?.remark || '';
    }
    const selectedSkuGroupList = this.store.getSelectedGroupListBySkuId(selectedSku.skuId);
    for (let i = 0; i < selectedSkuGroupList.length; i++) {
      const seGroupList = selectedSkuGroupList[i].groupSkuList;
      if (seGroupList && seGroupList.length > 0) {
        seGroupList.forEach((item) => {
          groupSkuReqIDs.push({ groupSkuId: item?.groupSkuId, count: item?.count });
          groupSkuIDs.push(item?.groupSkuId);
        });
      }
    }
    const locationObj = Mach.requireModule('SLLocation')?.getLocation();
    // 来源标识 1 一口价 3 919活动落地页 其他默认 0 店铺卡片
    const source = this.multiSkuSource.orderRequestSource;
    return {
      shopId: this.props.shopId,
      latitude: locationObj.latitude,
      longitude: locationObj.longitude,
      orderSource: source,
      requestSource: source,
      spuId: curGoodDetail?.spuId,
      channelCode: this.defaultGoodData?.channelCode || 0,
      skuList: [{
        skuId: selectedSku?.skuId,
        count,
        remark,
        groupSkuList: groupSkuIDs,
        groupSkuReqList: groupSkuReqIDs,
        // 当前提单按钮展示的discountPrice
        discountPrice: totalPrice.discountPrice
      }],
      [ORDER_REQUEST_BODY.finParam]: JSON.stringify(getDefaultPreDecisionParams())
    };
  }

  /* 锚点 */
  private anchorMustGroup = (groupId?: number) => {
    const skuId = this.state.selectedSku.skuId;
    const mustGroupList = this.store.getRequiredListBySkuId(skuId);
    const shouldHightLightList = this.store.getHighlightGroupBySkuId(skuId);
    // ----- mpweb适配origin -----
    // const shouldScrollY = this.topHeight + Mach.env.statusBarHeight + Mach.env.screenHeight * 0.1;
    // ----- mpweb适配change -----
    const shouldScrollY = this.topHeight - (Mach.env.screenHeight * 0.5);
    // ----- mpweb适配       -----
    if (shouldHightLightList && shouldHightLightList.length) {
      //震动 同样的值小米安卓要比ios强一点，所以双端进行区分一下
      KNB.vibrate({
        duration: Mach.env.isAndroid ? 50 : 100,
      });
      //变颜色
      const anchorGroupId = groupId || shouldHightLightList[0]; // 如果传入了groupId，则使用传入的groupId，否则使用第一个必选组
      shouldHightLightList.forEach((item) => {
        const attrRef = mustGroupList.find((mustGroup) => mustGroup.groupId === item)?.ref;
        const { current } = attrRef || {};
        if (current) {
          current.hightLightBg();
        }
      });

      // 设置动画
      const attrRef = mustGroupList.find((mustGroup) => mustGroup.groupId === anchorGroupId)?.ref;
      const { current } = attrRef || {};
      if (current) {
        current.setShowShakeAnimation();
      }

      //锚点
      if (this.tagLayouLab && this.tagLayouLab[anchorGroupId]) {
        const { y } = this.tagLayouLab[anchorGroupId];
        if (y + shouldScrollY < Mach.env.screenHeight / 2) {
          this.scroller?.scrollToOffset({ x: 0, y: 0 }, true);
        } else {
          this.scroller?.scrollToOffset({ x: 0, y: y + shouldScrollY - Mach.env.screenHeight / 2 }, true);
        }
      }
    }
  }

  /** 校验接口 */
  private validRequest = () => {
    this.submitLoading = true;
    const { t, checkSpuFail, addShopCart } = this.props;
    const { selectedSku, curGoodDetail, count } = this.state;
    const orderObj = this.getOrderData();
    const sku = orderObj.skuList[0];
    delete orderObj.skuList;
    const param = {
      ...orderObj,
      ...sku,
      userGetMode: this.userGetMode,
    };
    const shopCartSku = {
      skuId: selectedSku?.skuId,
      name: curGoodDetail?.name,
      picture: curGoodDetail?.pictures?.length ? curGoodDetail?.pictures[0] : ' ',
      originPrice: selectedSku?.originPrice,
      spuId: curGoodDetail?.spuId,
      count,
      remark: param.remark,
      skuSpec: selectedSku?.skuSpec,
      groupList: this.store.getSelectedGroupListBySkuId(selectedSku?.skuId),
    };
    const errCodes = [
      MULTI_SKU_ERROR_CODE.SHOP_REST,
      MULTI_SKU_ERROR_CODE.SHOP_OFFLINE,
      MULTI_SKU_ERROR_CODE.NO_INVENTORY,
      MULTI_SKU_ERROR_CODE.UNAVAILABLE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK,
      MULTI_SKU_ERROR_CODE.UN_SELECTED_REQUIRED_PRODUCT,
    ];

    ValidationRequest(param, t('shop_cartlayer_clear2'), {}, checkSpuFail)
      .then((res) => {
        // 监控埋点(一口价&919活动落地页&其它活动页)
        if (this.multiSkuSource.orderRequestSource > SOURCE_ORDER_REQUEST.SHOP_CART_POPUP) {
          this.multiSkuModalPrecheckRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
        }
        //酒类
        if (res.riskCheckTip) {
          this.submitLoading = false;
          this.setState({
            showDialog: true,
            dialogMsg: {
              title: res.riskCheckTip,
              rightText: t('shop_cartlayer_clear2'),
            },
          });
          return false;
        } else if (res.alcoholInfo?.hasAlcohol) {
          this.submitLoading = false;
          this.setState({
            showDialog: true,
            dialogMsg: {
              title: res.alcoholInfo.alcoholTips,
              leftText: res.alcoholInfo.cancelText,
              rightText: res.alcoholInfo.confirmText,
              onClickRightBtn: () => {
                this.setState({
                  showDialog: false,
                  dialogMsg: {
                    title: '',
                    leftText: '',
                    rightText: '',
                  }
                }, () => {
                  if (!this.previewLoading) {
                    this.orderRequest(this.getOrderData(), errCodes);
                  }
                });
              },
            },
          });
        } else {
          //门店预览和购物车浮层来源时，点击按钮是直接加购
          if (this.multiSkuSource.orderRequestSource === SOURCE_ORDER_REQUEST.SHOP_CART_POPUP) {
            addShopCart({ sku: shopCartSku, productCartIndex: this.productCartIndex, addCartSource: CHANGE_CART_SOURCE.MULTI_MODAL });
            this.handleModalHidden();
          } else {
            // 一口价及919活动及其它活动调用preview接口
            this.submitLoading = true;
            this.previewLoading = false;
            this.orderRequest(this.getOrderData(), errCodes);
          }
        }
      }, (error) => {
        // 在 preCheck 接口中，如果返回的是 string 类型的 error，说明已经进行了弹窗提示，不需要再次进行其他提示
        let hasShowedDialog = false;
        if (typeof error === 'string') {
          hasShowedDialog = true;
        }
        this.showRequestError(error, hasShowedDialog);
        // 监控埋点
        this.multiSkuModalPrecheckRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, error?.code ?? '-1');
      })
      .catch((error) => {
        console.log('validRequestError', error);
      });
  }

  //请求preview
  private orderRequest = (orderRequestParams: OrderRequest, errCodes: number[]) => {
    if (this.previewLoading) {
      return;
    }
    this.submitLoading = true;
    this.previewLoading = true;

    // 需要 传入活动 id 与资源 id
    if (this.activityId || this.resourceId) {
      if (orderRequestParams.extra) {
        orderRequestParams.extra.activityId = this.activityId;
        orderRequestParams.extra.resourceId = this.resourceId;
      } else {
        orderRequestParams.extra = {
          activityId: this.activityId,
          resourceId: this.resourceId
        };
      }
    }

    orderRequest(orderRequestParams, TypeRequest.PREVIEW, errCodes)
      .then((result) => {
        if (result) {
          const successToast = result?.successToast;
          if (successToast?.message) {
            KNB.toast({
              content: successToast.message,
              duration: successToast.duration || 2
            });
          }

          preloadPayment(result);

          shopMonitor.reportMetrics({
            FrontPaymentPreloadRate: 1
          }, {
            status: 1,
            source: 'multi-sku'
          });

          this.gotoOrderConfirmPage(result);//点击提单无效
        } else {
          this.submitLoading = false;
          this.previewLoading = false;
        }
        this.multiSkuModalPreviewRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
      }, (result) => {
        this.submitLoading = false;
        this.previewLoading = false;
        // 处理919活动异常Case弹窗
        const { code, message } = result || {};
        if (code === MULTI_SKU_ERROR_CODE.SHOP_REST || code === MULTI_SKU_ERROR_CODE.SHOP_PRODUCT_OFF) {
          this.showPreviewCommonDialog(code, message);
        } else if (code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE
          || code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK
          || code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE) {
          this.handleNineOneNineActivityDialog(code, message);
        } else if (code === MULTI_SKU_ERROR_CODE.UN_SELECTED_REQUIRED_PRODUCT) {
          this.handleUnSelectedRequiredProduct(message);
        } else if (this.source <= SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
          //source 大于3时，多规格弹窗一个单独弹窗容器加载，异常时不需要关闭多规格弹窗
          let hiddenModal = true;
          if (this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE) {
            // 一人食落地页 未登录状态下不需要关闭多规格弹层
            const isLogin = Login?.isLogin?.();
            if (!isLogin) {
              hiddenModal = false;
            }
          }
          if (hiddenModal) {
            this.handleModalHidden();
          }
        }
        this.multiSkuModalPreviewRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, code ?? '-1');
      });
  }

  /**
     * 高达搭建营销落地页来源时，弹必选菜未选择弹窗时，点击确认按钮需要跳转至对应的门店预览页并锚点到当前商品
     * @param message
     */
  // 有必选菜 逻辑,需要
  handleUnSelectedRequiredProduct = (message) => {
    let promptMsg;
    if (this.source <= SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
      //source 大于3时，多规格弹窗一个单独弹窗容器加载，异常时不需要关闭多规格弹窗
      this.handleModalHidden();
      promptMsg = message || i18nClient.getText('shouye_default_4');
    } else {
      promptMsg = i18nClient.getText('newerpage_guige_mustchoose_tips');
    }
    const Dialog = Mach.requireModule('Dialog');
    Dialog?.show({
      level: 1,
      title: promptMsg,
      rightButtonTitle: i18nClient.getText('shop_cartlayer_clear2')
    }, (res: any) => {
      if (res.which === -1 && this.source > SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
        // 点击右边按钮
        //跳转至对应的门店预览页并锚点到当前商品
        const shopId = this.props.shopId;
        const spuId = this.state.curGoodDetail?.spuId || 0;
        const categoryId = this.state.curGoodDetail?.firstCategoryId || 0;
        const shopScheme = `sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_shop&spuId=${spuId}&categoryId=${categoryId}&shopId=${shopId}&orderSource=${this.source}`;
        WMRouter.navigateTo(shopScheme, {}, (result) => { this.close(); });
      }
    });
  }

  // 显示单按钮弹窗
  showPreviewCommonDialog = (code, message) => {
    const { t, shopId = -999, brandId = -999 } = this.props;
    // 用户活动状态
    const userStatus = this.getLxUserActivityStatus();
    // 获取弹窗原因
    const remindReason = this.getLxRemindReason(code);
    this.setState({
      showDialog: true,
      dialogMsg: {
        title: '',
        message,
        rightText: t('shop_cartlayer_clear2'),
        onClickRightBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          }, () => {
            // 关闭规格弹窗
            this.handleModalHidden();
            // 弹窗点击事件
            TrackUtils.reportPreviewCommonDialog(EVENT_TYPE.MC, this.source, shopId, userStatus, brandId, remindReason);
          });
        },
        onClickMask: () => { },
      },
    });
    // 弹窗曝光
    TrackUtils.reportPreviewCommonDialog(EVENT_TYPE.MV, this.source, shopId, userStatus, brandId, remindReason);
  }

  // 处理919活动异常Case弹窗
  handleNineOneNineActivityDialog = (code, message) => {
    const errCodes = [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE, MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK, MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE];
    if (!errCodes.includes(code) || message?.length === 0) {
      return;
    }
    const title = i18nClient.getText('mkt_promo_activitynomore');
    const leftText = i18nClient.getText('mkt_promo_return');
    const rightText = i18nClient.getText('mkt_promo_browsestore');
    const { shopId, brandId = -999 } = this.props;
    const userStatus = this.getLxUserActivityStatus();
    // 提示原因
    const remindReason = this.getLxRemindReason(code);
    this.setState({
      showDialog: true,
      dialogMsg: {
        title,
        message,
        leftText,
        rightText,
        onClickLeftBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          });
          // 返回首页
          this.handleModalHidden();
          WMRouter.navigateTo(Constant.HOME_PAGE);
        },
        onClickRightBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          }, () => {
            // 跳转到店铺页
            this.handleModalHidden();
            const url = buildUrl(Constant.SHOP_PAGE, { shopId: this.props.shopId });
            WMRouter.navigateTo(url, null, () => { });
          });
        },
        onClickMask: () => { },
      },
    });
  }

  // 跳转提单页
  private gotoOrderConfirmPage = (orderResponse: any) => {
    const multiSkuModel: MultiSkuModel = this.props.multiSkuModel || {};
    const WMRouter = Mach.requireModule('Router');
    const bundleName = 'mach_pro_sailor_c_order_confirm';
    const orderResponseParams = encodeURIComponent(JSON.stringify(orderResponse));
    const channelCode = this.defaultGoodData?.channelCode || 0;

    const searchParams = {
      mach_bundle_name: bundleName,
      order_info: orderResponseParams,
      channel_code: channelCode,
      activity_id: this.activityId,
      resource_id: this.resourceId,
      attributionInfo: encodeURIComponent(multiSkuModel.attributionInfo),
      extraData: encodeURIComponent(JSON.stringify({
        bundleName: Mach.env.bundleName ?? '',
        bundleVersion: Mach.env.bundleVersion ?? '',
        source: this.source
      }))
    };

    const urlScheme = buildUrl('sailorc://keeta.com/machpro', searchParams);

    shopMonitor.reportMetrics({
      [RAPTOR_KEYS.BeforeRouterNavigateToOrderConfirm]: 1
    }, {
      source: this.source
    });

    WMRouter.navigateTo(urlScheme, {}, (result: any) => {
      if (result.success) {
        this.close();
      } else {
        this.previewLoading = false;
        this.submitLoading = false;
        Toast.show(i18nClient.getText('shouye_default_4'), 2, {
          code: result?.error?.code || '0',
          extraInfo: {
            ...result,
            url: urlScheme,
            msg: 'gotoOrderConfirmPage跳转提单页失败',
          },
        });
      }
    });
  }

  /**
     * 改变加购数量
     * @param count 数量
     * @param purchaseType  0 减购 1 加购
     */
  private changeCountNumber = (count: number, purchaseType: number) => {
    this.calculatePriceByBE(this.state.selectedSku, count, purchaseType);
  }

  /**
     * 删除当前菜品（从购物车浮层进来的，可以减购到0）
     */
  private deleteShopCartItem = () => {
    const { deleteUnavailableSku } = this.props;
    if (this.productCartIndex !== undefined) {
      deleteUnavailableSku(this.productCartIndex);
      this.handleModalHidden();
    }
  }

  //关闭备注页的键盘
  private closeKeyBoard = () => {
    const { current } = this.remarkRef || {};
    if (current) {
      current.inputBlur?.();
    }
  }

  private scrollUpRemark = (source) => {
    const { curGoodDetail } = this.state;
    TrackUtils.reportRemark(EVENT_TYPE.MC, source, this.props.shopId, this.state.selectedSku.skuId, this.props.multiSkuModel, curGoodDetail, this.props.shopId, this.state.couponTips?.canUserCoupon);
    if (this.scroller) {
      this.setState({
        scrollerBottom: 270 - Mach.env.softMenuBarHeight,
      }, () => {
        setTimeout(() => {
          this.scroller?.scrollToOffset({ x: 0, y: this.remarkY }, true);
        }, 100);
      });
    }
  }

  private scrollDowmRemark = () => {
    if (this.scroller) {
      this.setState({
        scrollerBottom: 50,
      }, () => {
        this.scroller?.scrollToOffset({ x: 0, y: this.remarkY }, true);
      });
    }
  }

  private isFixedPriceSource = () => this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE

  //规格模块曝光埋点
  private onItemAppear = (groupData: GoodDetailGroupList) => {
    const { curGoodDetail, selectedSku } = this.state;
    const groupSkuCount = this.defaultGoodData ? this.findDefaultGroupData(groupData.groupId)?.length : 0;
    const ruleTag = selectedSku?.promotionTags?.[0]?.ruleTag?.tags?.[0].subTags?.[1]?.text || '';
    const discountPrice = selectedSku?.discountPrice?.displayAmount || '';
    const activityType = selectedSku?.activityInfoList?.[0]?.activityType || 0;
    // 组件高度 + 上方图片及sku的高度 - 滚动距离 < 浮层高度 - 购物车高度
    if (!this.tagViewLab[groupData.groupId]) {
      this.tagViewLab[groupData.groupId] = true;
      TrackUtils.reportAttrGroup(
        EVENT_TYPE.MV,
        this.source,
        this.props.shopId,
        curGoodDetail?.spuId || 0,
        groupSkuCount || 0,
        groupData.groupName,
        ruleTag,
        discountPrice,
        activityType,
        this.props.multiSkuModel,
        curGoodDetail,
        this.state.couponTips?.canUserCoupon
      );
    }
  }

  private onskuItemAppear = (sku: GoodDetailSkuList, curGoodDetail) => {
    const { x } = this.tagLayouLab[sku.skuId] || {};
    const offset = this.state.scrollOffset || 0;
    if (x - offset <= Mach.env.screenWidth - 16) {
      this.tagViewLab[sku.skuId] = true;
      TrackUtils.reportVariation(EVENT_TYPE.MV, {
        source: this.source,
        logData: sku.extraInfo?.logData,
        spuCalorie: sku.calorie,
        multiSkuModel: this.props.multiSkuModel,
        curGoodDetail,
        shopId: this.props.shopId,
        canUserCoupon: this.state.couponTips?.canUserCoupon,
        totalPrice: this.state.totalPrice,
        sku: this.state.selectedSku
      });
    }
  }

  /**
   * 获取下一个未选中的必选组
   * @param skuId 当前skuId
   * @param currentGroupId 当前组ID
   * @returns 下一个未选中的必选组ID，如果没有则返回null
   */
  public getNextRequiredGroup = (skuId: number, currentGroupId: number): number | null => {
    const mustGroupList = this.store.getRequiredListBySkuId(skuId);
    if (!mustGroupList?.length) return null;

    // 获取当前组的索引
    const currentIndex: number = mustGroupList.findIndex((group) => group.groupId === currentGroupId);
    if (currentIndex === -1) return null;

    // 从当前组的下一个开始查找未选中的组
    for (let i = currentIndex + 1; i < mustGroupList.length; i++) {
      const group = mustGroupList[i];
      const selectedGroupList = this.store.getSelectedGroupListBySkuId(skuId);
      const isSelected = selectedGroupList.some((selectedGroup) => selectedGroup.groupId === group.groupId);

      if (!isSelected) {
        return group.groupId;
      }
    }

    return null;
  }

  /**
   * 处理组完成事件 锚定下一个必选组
   * @param nextGroupId 下一个必选组ID
   */
  private handleGroupCompleted = (nextGroupId: number) => {
    const { selectedSku } = this.state;
    const mustGroupList = this.store.getRequiredListBySkuId(selectedSku?.skuId);
    const group = mustGroupList?.find((g) => g.groupId === nextGroupId);
    if (group) {
      // 执行锚定
      this.anchorMustGroup(nextGroupId);
    }
  }
}

export default withTranslation('', {
  withRef: true,
})(MultiSkuModal);
